import React, { FC } from 'react'
import { UserEmailSpanProps } from './types/UserEmailSpanProps'

export const UserEmailSpan: FC<UserEmailSpanProps> = ({
  className = '',
  email,
}) => {
  return <span className={`UserEmailSpan ${className}`}>{email}</span>
}
